import { Outlet, useLocation } from 'react-router-dom';
import HeaderComponent from '../../Header/HeaderNewsletter';
import BugReportFAB from '../../BugReportFAB';

const NewsletterLayout = () => {
  const location = useLocation();

  const isDiscoveryPage = location.pathname === '/';

  return (
    <div className="newsletter-layout m-auto">
      <HeaderComponent />
      <div className="mt-[68px] md:mt-[80px] px-0 md:px-[8px] mb-[80px]">
        <Outlet />
      </div>
      <BugReportFAB hasWelcomeGuide={isDiscoveryPage} />
    </div>
  );
};

export default NewsletterLayout;
